import React from "react";
import Cta from "../../Shared/Cta";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import CustomInput from "../../Shared/CustomInput";
import CustomSelect from "../../Shared/CustomSelect";
import { expanseOption, statusOption } from "../../utils/helpers";
import { date } from "yup";
import SubmitForm from "../../Shared/SubmitForm";
const AddExpenses = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    console.log("submitting data ", data);
  };
  return (
    <>
      <div class="breadcrumbs-area">
        <h3>Accounts</h3>
        <ul>
          <li>
            <Link to="/admin">Home</Link>
          </li>
          <li>Add New Expense</li>
        </ul>
      </div>

      <div class="card height-auto">
        <div class="card-body">
          <div class="heading-layout1">
            <div class="item-title">
              <h3>Add New Expense</h3>
            </div>
            <Cta />
          </div>
          <form class="new-added-form" onSubmit={handleSubmit(onSubmit)}>
            <div class="row">
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Name *"}
                  register={register}
                  errors={errors}
                  name={"name"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"ID NO *"}
                  register={register}
                  errors={errors}
                  name={"name"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Expanse Type *"}
                  register={register}
                  errors={errors}
                  name={"subject"}
                  placeholder={"Please Select Expanse"}
                  option={expanseOption}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Amount *"}
                  register={register}
                  errors={errors}
                  name={"amount"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Phone *"}
                  register={register}
                  errors={errors}
                  name={"phone"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Email *"}
                  register={register}
                  errors={errors}
                  name={"email"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Status *"}
                  register={register}
                  errors={errors}
                  name={"status"}
                  placeholder={"Please select Status"}
                  option={statusOption}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Date *"}
                  register={register}
                  errors={errors}
                  type={date}
                  name={"date"}
                />
              </div>
              <SubmitForm />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddExpenses;
